'use client';

import { useContext } from 'react';
import { FlagsContext } from '@storefront/context/LDFlagsContext';
import {
  getAemCallbackURL,
  getCurrentProductConfigurationURL,
  getFallbackURL,
} from '@storefront/services/SessionHelperService/sessionHelperService';
import ErrorInformationV2 from './v2/shared-components/error-information-v2/error-information';
import ErrorInformation from '@storefront/shared-components/error-information/error-information';
import { useTranslation } from 'react-i18next';

import styles from '../app/pdp-config/error.p.module.scss';
import stylesVisID from './layout.module.scss';
import Header from '../shared-components/header/header';

export default function NotFound() {
  const { enableVisID = false } = useContext(FlagsContext) ?? {};
  const { t } = useTranslation('common', {
    keyPrefix: 'errors.PAGE_NOT_FOUND',
  });

  const errorProps = {
    errorId: 'PageNotFound',
    code: t('code'),
    title: t('title'),
    description: t('description'),
    buttonDetails: {
      redirectToURL: t('redirectUrl', {
        aemURL: getAemCallbackURL() ?? getFallbackURL(),
        hpStoreURL: getFallbackURL(),
      }),
      label: t('buttonLabel'),
    },
    redirectLink: {
      title: t('redirectTitle'),
      link: t('redirectLink', {
        currentProductConfigurationURL:
          getCurrentProductConfigurationURL() ?? getFallbackURL(),
      }),
    },
  };

  return (
    <div
      className={enableVisID ? stylesVisID['container'] : styles['container']}
    >
      <Header />
      {enableVisID ? (
        <div className={stylesVisID['error-container']}>
          <ErrorInformationV2 {...errorProps} />
        </div>
      ) : (
        <ErrorInformation {...errorProps} />
      )}
    </div>
  );
}
